import { css } from '@emotion/react';
import { Main } from '@constants/color';

export const guideText = css({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '26px',
  color: Main.priBlue,
  marginTop: 24
});
